/**
 * @typedef {""|"Autorizada"|"PendienteARCA"|"ErrorARCA"|"Anulada"|"SinSeguimiento"} EstadoFacturaHistorial
 * @typedef {""|"PendienteFacturacion"|"Facturado"|"Anulado"} EstadoRemitoHistorial
 * @typedef {{
 * FacturaId:number, Fecha:string, TipoComprobanteId:number, TipoComprobante:string,
 * PuntoVenta:number, Numero:number, Comprobante:string, ClienteId:number,
 * ClienteCodigo:string, Cliente:string, ClienteDocumento:string, Neto:number,
 * Iva:number, Tributos:number, Total:number, Activa:boolean, Estado:string,
 * Cae:string, VencimientoCae?:string|null, Remitos:string, VentaId?:number|null,
 * UltimoError:string, PuedeDescargarPdf:boolean, PuedeReintentarArca:boolean
 * }} FacturaHistorialItem
 * @typedef {{
 * RemitoId:number, Fecha:string, PuntoVenta:number, Numero:number, Comprobante:string,
 * ClienteId:number, ClienteCodigo:string, Cliente:string, ClienteDocumento:string,
 * DespachoId?:number|null, VentaId?:number|null, FacturaId?:number|null,
 * Factura:string, Activo:boolean, Estado:string, PuedeFacturar:boolean
 * }} RemitoHistorialItem
 * @typedef {{Linea:number, MercaderiaId:number, Codigo:string, Descripcion:string,
 * Cantidad:number, CantidadSinCargo:number, PrecioNeto:number,
 * PorcentajeDescuento:number, PorcentajeIva:number, Neto:number, Iva:number,
 * Total:number}} FacturaDetalleLinea
 */

export const CONTRATOS_COMPROBANTES = Object.freeze({
  estadosFactura: ["", "Autorizada", "PendienteARCA", "ErrorARCA", "Anulada", "SinSeguimiento"],
  estadosRemito: ["", "PendienteFacturacion", "Facturado", "Anulado"],
});
